import { SharedCommonUtility } from '../utils/common.utility';
import { $severity } from './accessibility';
import type { ECBasicOption, EChartsOption } from 'echarts/types/dist/shared';

export const ECHARTS_BASE_THEME_NAME: Readonly<string> = 'reporting-agent';

export const CHART_TEXT_COLOR = '#111215';

export const ECHARTS_BASE_THEME: Readonly<EChartsOption> = SharedCommonUtility.freezeDeep({
  color: ['#D82E9A', '#231455', '#1F2DF5', '#36188A'],
  legend: {
    bottom: 'bottom',
  },
  title: {
    left: 'left',
    textStyle: {
      fontSize: 16,
      fontWeight: 600,
      color: CHART_TEXT_COLOR,
    },
  },
  animation: false,
  aria: {
    enabled: true,
    decal: {
      show: true,
      decals: [
        {
          color: '#F5F0E6',
          dashArrayX: [1, 0],
          dashArrayY: [1, 7],
          symbolSize: 1,
          rotation: 45,
        },
        {
          color: '#F5F0E6',
          symbol: 'circle',
          dashArrayX: [
            [4, 6],
            [0, 6, 4, 0],
          ],
          dashArrayY: [6, 4],
          symbolSize: 0.8,
        },
        {
          color: '#F5F0E6',
          symbol: 'triangle',
          dashArrayX: [
            [10, 10],
            [0, 10, 10, 0],
          ],
          dashArrayY: [10, 5],
          symbolSize: 0.75,
        },
        {
          color: '#F5F0E6',
          dashArrayX: [1, 0],
          dashArrayY: [1, 7],
        },
      ],
    },
  },
  line: {
    symbolSize: 7,
  },
});

export const ECHARTS_GENERATIVE_THEME_NAME: Readonly<string> = 'chat-agent-generative-theme';

export const ECHARTS_GENERATIVE_THEME: Readonly<EChartsOption> = SharedCommonUtility.freezeDeep({
  color: [
    '#D82E9A', // Coral500
    '#1F2DF5', // Blue500
    '#298335', // Green500
    '#F48506', // Orange500
    '#5B1FF4', // Purple500
    '#3696C2', // Teal500
    '#F9C407', // Gold500
    '#231455', // Purple800
  ],
  legend: {
    bottom: 'bottom',
  },
  title: {
    left: 'left',
    textStyle: {
      fontSize: 16,
      fontWeight: 600,
      color: CHART_TEXT_COLOR,
    },
  },
  animation: false,
  aria: {
    enabled: true,
    decal: {
      show: true,
      decals: [
        {
          color: '#F5F0E6',
          dashArrayX: [1, 0],
          dashArrayY: [1, 7],
          symbolSize: 1,
          rotation: 45,
        },
        {
          color: '#F5F0E6',
          symbol: 'circle',
          dashArrayX: [
            [4, 6],
            [0, 6, 4, 0],
          ],
          dashArrayY: [6, 4],
          symbolSize: 0.8,
        },
        {
          color: '#F5F0E6',
          symbol: 'triangle',
          dashArrayX: [
            [10, 10],
            [0, 10, 10, 0],
          ],
          dashArrayY: [10, 5],
          symbolSize: 0.75,
        },
        {
          color: '#F5F0E6',
          dashArrayX: [1, 0],
          dashArrayY: [1, 7],
        },
        {
          color: '#F5F0E6',
          dashArrayX: [1, 0],
          dashArrayY: [1, 7],
          symbolSize: 1,
          rotation: -45,
        },
        {
          color: '#F5F0E6',
          symbol: 'rect',
          dashArrayX: [
            [6, 10],
            [0, 10, 6, 0],
          ],
          dashArrayY: [8, 6],
          symbolSize: 0.7,
        },
        {
          color: '#F5F0E6',
          symbol: 'diamond',
          dashArrayX: [
            [8, 8],
            [0, 8, 8, 0],
          ],
          dashArrayY: [8, 4],
          symbolSize: 0.8,
        },
        {
          color: '#F5F0E6',
          dashArrayX: [1, 7],
          dashArrayY: [1, 0],
          symbolSize: 1,
        },
      ],
    },
  },
  line: {
    symbolSize: 7,
  },
});

export const ECHARTS_BASE_OPTIONS: Readonly<ECBasicOption> = Object.freeze({
  tooltip: {
    show: true,
  },
  legend: {
    show: true,
  },
});

export const SeverityColours: ReadonlyMap<$severity, string> = SharedCommonUtility.freezeDeep(
  new Map([
    [$severity.critical, '#231455'],
    [$severity.high, '#1F2DF5'],
    [$severity.low, '#36188A'],
  ]),
);

export const TableColors = SharedCommonUtility.freezeDeep({
  oddRowBg: '#FFFFFF',
  evenRowBg: '#EEF2FF',
  headerBg: '#4338CA',
  headerText: '#FFFFFF',
  border: '#E5E7EB',
} as const);

export const DOCX_HTML_BODY_STYLES = SharedCommonUtility.freezeDeep({
  bodyColor: '#374151',
  fontFamily: 'Arial, sans-serif',
  paragraphFontSize: '11pt',
} as const);
